<script>
import _debounce from "lodash/debounce";
import router from "@/mixins/router";
import DatePicker from "vue2-datepicker";
import {mapGetters} from "vuex";
import constant from "@/configs/constant";

const REGULARLY_RESERVATION_WEEKLY = 1;
const REGULARLY_RESERVATION_BIWEEKLY = 2;
const REGULARLY_RESERVATION_MONTHLY = 3;

export default {
  props: ["data", "isUpdate"],
  mixins: [router],
  components: {
    DatePicker
  },
  data() {
    return {
      isLoading: false,
      dataSelected: {
        zz_regularly_reservation_interval_id: REGULARLY_RESERVATION_WEEKLY,
        regularly_reservation_start_date: "",
        regularly_reservation_end_date: "",
        regularly_reservation_date_of_month: "",
        regularly_reservation_day_of_week: []
      },
    };
  },
  created() {
    if (this.isUpdate) {
      this.dataSelected.zz_regularly_reservation_interval_id = this.data.zz_regularly_reservation_interval_id
      this.dataSelected.regularly_reservation_start_date = this.data.regularly_reservation_start_date
      this.dataSelected.regularly_reservation_end_date = this.data.regularly_reservation_end_date
      this.dataSelected.regularly_reservation_date_of_month = this.data.regularly_reservation_date_of_month
      this.dataSelected.regularly_reservation_day_of_week = this.data.regularly_reservation_day_of_week
    }
  },
  methods: {
    updateValue() {
      let customDataSelected = {...this.dataSelected};
      let work_periodically = this.options_tables.zz_regularly_reservation_intervals.find(work => work.id == customDataSelected.zz_regularly_reservation_interval_id);
      customDataSelected.work_periodically_type = {
        id: customDataSelected.id,
        text: work_periodically.regularly_reservation_interval
      };
      if (customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_MONTHLY) {
        customDataSelected.regularly_reservation_date_of_month = '';
      }
      if (customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_WEEKLY && customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_BIWEEKLY) {
        customDataSelected.regularly_reservation_day_of_week = [];
      }
      this.$emit("dataSelected", customDataSelected);
      this.$bvModal.hide("regular-reservation");
    },
    disabledDateForStartDate: function (date) {
      return date.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    days_of_the_week() {
      return constant.DAY_OF_WEEKS;
    },
    isDateOfMonth() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_MONTHLY ? true : false;
    },
    isDateOfWeek() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_WEEKLY
      || this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_BIWEEKLY ? true : false;
    },
    checkValidate() {
      let data = this.dataSelected;
      if (this.isDateOfMonth && (!data.regularly_reservation_date_of_month || data.regularly_reservation_date_of_month < 1 || data.regularly_reservation_date_of_month > 31)) return false;
      if (this.isDateOfWeek && !data.regularly_reservation_day_of_week.length) return false;
      if (!data.regularly_reservation_start_date) return false;
      if (!data.regularly_reservation_end_date) return false;

      return true;
    }
  }
};
</script>
<template>
  <div class="d-xl-flex">
    <button
      v-b-modal.regular-reservation
      class="btn btn-primary w-md waves-effect waves-light w-100"
    >
      定期予約
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="regular-reservation"
      centered
      title-class="font-18"
      hide-footer
      hide-header
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <ValidationObserver v-slot="{ invalid }">
            <b-row class="select-date">
              <b-col>
                <ValidationProvider
                  rules="required"
                  :custom-messages="{ required: '開始年月日は必須項目です' }"
                  v-slot="{ errors, classes }"
                >
                  <div class="custom-datepicker gap-2">
                    <label for="start_date">開始年月日</label>
                    <div :class="classes" class="input-control">
                      <date-picker
                        v-model="dataSelected.regularly_reservation_start_date"
                        lang="ja"
                        placeholder="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        value-type="YYYY-MM-DD"
                        position="left"
                        :disabled-date="disabledDateForStartDate"
                      ></date-picker>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col cols="1" class="split text-center">
                <span>～</span>
              </b-col>
              <b-col>
                <ValidationProvider
                  name="開始年月日"
                  rules="required"
                  :custom-messages="{ required: '終了年月日は必須項目です' }"
                  v-slot="{ errors, classes }"
                >
                  <div class="custom-datepicker gap-2">
                    <label for="end_date">終了年月日</label>
                    <div class="input-control" :class="classes">
                      <date-picker
                        v-model="dataSelected.regularly_reservation_end_date"
                        lang="ja"
                        placeholder="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        value-type="YYYY-MM-DD"
                        :disabled-date="disabledDateForStartDate"
                        position="left"
                      ></date-picker>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col cols="4" class="d-flex align-items-center">
                <div class="custom-radio-group">
                  <b-form-radio-group
                    class="radio-group"
                    id="works_periodically"
                    v-model="dataSelected.zz_regularly_reservation_interval_id"
                    name="work-order-types-options"
                  >
                    <b-form-radio v-for="option in options_tables.zz_regularly_reservation_intervals" :value="option.id"
                                  disabled-field="notEnabled">{{ option.regularly_reservation_interval }}
                    </b-form-radio>
                  </b-form-radio-group>
                </div>
              </b-col>
              <b-col cols="2">
                <div class="input-control">
                  <div class="custom-input number-of-date gap-2">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <ValidationProvider
                        name="日"
                        :rules="isDateOfMonth ? 'required|min_value:1|max_value:31' : ''"
                        :custom-messages="{ required: '{_field_}は必須項目です', min_value:'{_field_}は{min}以上でなければなりません', max_value:'{_field_}は{max}以下でなければなりません'}"
                        v-slot="{ errors, classes }"
                      >
                        <div class="input-control" :class="classes">
                          <b-form-input
                            type="number"
                            class="d-flex gap-3"
                            v-model="dataSelected.regularly_reservation_date_of_month"
                            name="number-of-date"
                            :disabled="!isDateOfMonth"
                            :aria-describedby="ariaDescribedby"
                          >
                          </b-form-input>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <div class="align-self-center">日</div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-4">

              <div class="custom-checkbox-core">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <ValidationProvider
                    :rules="isDateOfWeek ? 'required' : ''"
                    :custom-messages="{ required: '必須項目です' }"
                    v-slot="{ errors, classes }"
                  >
                    <div class="input-control" :class="classes">
                      <b-form-checkbox-group
                        :disabled="!isDateOfWeek"
                        id="checkbox-group-days-of-the-week"
                        class="d-flex gap-3"
                        v-model="dataSelected.regularly_reservation_day_of_week"
                        :options="days_of_the_week"
                        :aria-describedby="ariaDescribedby"
                        name="checkbox-group-days-of-the-week"
                      ></b-form-checkbox-group>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </div>

            </b-row>
            <div class="d-flex justify-content-end mt-4">
              <button
                @click="updateValue"
                class="btn btn-primary w-md waves-effect waves-light"
                :disabled="!checkValidate"
              >
                <i class='fas fa-check'></i> 確定
              </button>
            </div>
          </ValidationObserver>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped lang="scss">
.select-date {
  .split {
    font-size: 25px;
  }
}

.custom-datepicker label {
  align-self: unset;
}

.input-control.invalid span {
  white-space: nowrap;
}
</style>
